import React, { useState } from "react";
import UploadForm from "./components/UploadForm";
import ReactMarkdown from "react-markdown";
import KPICard from "./components/KPICard";
import "./App.css";

function App() {
  const [statementInfo, setStatementInfo] = useState(null);
  const [insights, setInsights] = useState(null);
  const [role, setRole] = useState("cfo");
  const [activeKpi, setActiveKpi] = useState(null);
  
  return (
          <div className="container">
            <h1>AI Financial Statement Analyst</h1>
            
      <div className="role-switch">
        <button
          className={role === "cfo" ? "active" : ""}
          onClick={() => setRole("cfo")}
        >
          CFO
        </button>

        <button
          className={role === "founder" ? "active" : ""}
          onClick={() => setRole("founder")}
        >
          Founder
        </button>

        <button
          className={role === "analyst" ? "active" : ""}
          onClick={() => setRole("analyst")}
        >
          Analyst
        </button>
      </div>
      <UploadForm
        setStatementInfo={setStatementInfo}
        setInsights={setInsights}
       
      />
      

      {/* Statement Info Card */}
      {statementInfo  && typeof insights === "object" && (
        <div className="card">
          <h3>📄 Statement Info</h3>
          <p><strong>Type:</strong> {statementInfo.statement_type}</p>
          {statementInfo.company_name && (
            <p><strong>Company:</strong> {statementInfo.company_name}</p>
          )}
        </div>
      )}

      {/* Insights Cards */}

         {insights?.kpis && (
              <div className="card">
                <h3>📊 Key KPIs</h3>

                <div className="kpi-chips">
                  {insights.kpis.map((kpi, idx) => (
                    <div
                      key={idx}
                      className={`kpi-chip ${kpi.trend}`}
                      onClick={() =>
                        setActiveKpi(activeKpi === idx ? null : idx)
                      }
                    >
                      <strong>{kpi.name}</strong>: {kpi.value}
                      {kpi.trend === "positive" ? " ↑" : " ↓"}
                    </div>
                  ))}
                </div>
              </div>
            )}
          {activeKpi !== null && insights?.kpis && (
              <div className="card kpi-detail-card">
                <h3>{insights.kpis[activeKpi].name}</h3>

                <p>{insights.kpis[activeKpi].description}</p>

                <p>
                  <strong>Value:</strong> {insights.kpis[activeKpi].value}
                </p>

                <p>
                  <strong>Trend:</strong>{" "}
                  {insights.kpis[activeKpi].trend === "positive"
                    ? "▲ Positive"
                    : "▼ Negative"}
                </p>
              </div>
            )}

   

      {insights && typeof insights === "object" && (
        <div className="insights-grid">

          {insights.key_insights && (
            <div className="card">
              <h3>📊 Key Insights</h3>
              <ReactMarkdown>
                {String(insights.key_insights||"")}
              </ReactMarkdown>
            </div>
          )}

         


          {insights.risks && (
            <div className="card">
              <h3>⚠️ Risks & Red Flags</h3>
              <ReactMarkdown>
                {String(insights.risks||"")}
              </ReactMarkdown>
            </div>
          )}

          {insights.recommendations && (
            <div className="card">
              <h3>✅ Recommendations</h3>
              <ReactMarkdown>
                {String(insights.recommendations||"")}
              </ReactMarkdown>
            </div>
          )}

        </div>
      )}
    </div>
  );
}

export default App;
